import type { TranslationDict } from '../en';

const uk: TranslationDict = {
  'header.buy': 'Купити',
  'header.sell': 'Продати',
  'spend.label': 'Ви витрачаєте',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Ви отримуєте',
  'payment.label': 'Спосіб оплати',
  'payment.select': 'Обрати',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Немає доступних способів оплати для цієї пари',
  'wallet.label': 'Адреса гаманця одержувача',
  'wallet.placeholderBuy': 'Введіть адресу отримання',
  'wallet.placeholderSell': 'Введіть адресу відправлення',
  'wallet.validating': 'Перевірка адреси...',
  'wallet.invalid': 'Введіть дійсну адресу гаманця',
  'wallet.invalidServer': 'Недійсна адреса гаманця',
  'cta.buy': 'Купити {crypto}',
  'cta.sell': 'Продати {crypto}',
  'cta.gettingPrice': 'Отримуємо найкращу ціну...',
  'cta.processing': 'Обробка...',
  'footer.poweredBy': 'Працює на ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Деталі курсу',
  'rate.close': 'Закрити',
  'rate.updatesIn': 'Курс оновиться через 00:{seconds}',
  'rate.noQuote': 'Котирування недоступне',
  'rate.exchangeRate': 'Обмінний курс',
  'rate.processingFee': 'Комісія за обробку',
  'rate.networkFee': 'Комісія мережі',
  'rate.provider': 'Провайдер',
  'toast.orderCreated': 'Замовлення створено',
  'toast.redirecting': 'Перенаправлення на оплату...',
  'toast.orderFailed': 'Замовлення не вдалося',
  'toast.couldNotCreate': 'Не вдалося створити замовлення',
  'toast.quoteError': 'Помилка котирування',
  'toast.noProviders': 'Немає провайдерів',
  'toast.somethingWrong': 'Щось пішло не так',
  'error.amountZero': 'Сума повинна бути більше 0',
  'error.minAmountFiat': 'Мінімальна сума — {min} {currency}',
  'error.minAmountCrypto': 'Мінімальна сума — {min} {currency}',
  'error.noProviders': 'Немає доступних провайдерів для цієї комбінації',
  'error.currencyUnavailableBuy': 'Ця валюта недоступна для купівлі',
  'error.currencyUnavailableSell': 'Ця валюта недоступна для продажу',
  'parity.info': 'З вас буде стягнуто за {receiveAmount} {crypto}, решта до {spendAmount} {fiat} буде зараховано на ваш рахунок {partner}',
  'redirect.secureBadge': 'Безпечний платіж',
  'redirect.title': 'Продовжити оплату',
  'redirect.description': 'Вас буде перенаправлено на {gateway} для завершення оплати.',
  'redirect.countdown': 'Перенаправлення через {seconds}...',
  'redirect.openTab': 'Відкрити ACH у новій вкладці',
  'redirect.cancel': 'Скасувати',
  'checkout.noOrder': 'Замовлення не знайдено',
  'checkout.goBack': 'Повернутися',
  'checkout.expired': 'Час оплати вичерпано',
  'checkout.expiredDesc': 'Сесія закінчилася. Будь ласка, спробуйте знову.',
  'checkout.startOver': 'Почати спочатку',
  'checkout.cancel': 'Скасувати',
  'checkout.loading': 'Завантаження оплати...',
  'checkout.iframeTitle': 'Оплата через провайдера',
  'checkout.widgetTitle': 'Оплата замовлення',
  'checkout.unknownMethod': 'Невідомий метод оплати',
  'processing.default': 'Обробка вашого замовлення...',
  'processing.pending': 'Очікування підтвердження оплати...',
  'processing.active': 'Обробка вашої транзакції...',
  'processing.generic': 'Обробка...',
  'processing.checkingStatus': 'Перевірка статусу...',
  'processing.orderId': 'ID замовлення',
  'processing.provider': 'Провайдер',
  'processing.amount': 'Сума',
  'processing.receiving': 'Отримання',
  'processing.network': 'Мережа',
  'processing.toAddress': 'На адресу',
  'processing.usuallyMinutes': 'Зазвичай це займає кілька хвилин.',
  'processing.safeToClose': 'Ви можете безпечно закрити цю сторінку — ми надішлемо вам email після завершення.',
  'complete.buyTitle': 'Покупку завершено!',
  'complete.sellTitle': 'Продаж завершено!',
  'complete.buyDesc': 'Ваші {crypto} надіслано на ваш гаманець.',
  'complete.sellDesc': 'Ваша виплата в {fiat} обробляється.',
  'complete.amountBuy': 'Отримана сума',
  'complete.amountSell': 'Продана сума',
  'complete.paidBuy': 'Сплачена сума',
  'complete.paidSell': 'Сума виплати',
  'complete.network': 'Мережа',
  'complete.wallet': 'Гаманець',
  'complete.transaction': 'Транзакція',
  'complete.provider': 'Провайдер',
  'complete.orderId': 'ID замовлення',
  'complete.completed': 'Завершено',
  'complete.viewExplorer': 'Переглянути в Explorer',
  'complete.done': 'Готово',
  'errorStep.failed': 'Оплата не вдалася',
  'errorStep.cancelled': 'Замовлення скасовано',
  'errorStep.expired': 'Замовлення прострочено',
  'errorStep.refunded': 'Замовлення повернуто',
  'errorStep.unknown': 'Щось пішло не так',
  'errorStep.failedBuy': 'Ваш платіж не вдалося обробити. Будь ласка, спробуйте знову або скористайтеся іншим способом оплати.',
  'errorStep.failedSell': 'Ваш продаж не вдалося обробити. Будь ласка, спробуйте знову.',
  'errorStep.cancelledBuy': 'Ваше замовлення було скасовано. Оплату не було здійснено.',
  'errorStep.cancelledSell': 'Ваш продаж було скасовано. Криптовалюту не було переказано.',
  'errorStep.expiredBuy': 'Ваше замовлення прострочено. Будь ласка, розпочніть нову покупку.',
  'errorStep.expiredSell': 'Ваше замовлення прострочено. Будь ласка, розпочніть новий продаж.',
  'errorStep.refundedBuy': 'Ваш платіж було повернуто. Кошти з\'являться на вашому рахунку протягом 5-10 робочих днів.',
  'errorStep.refundedSell': 'Вашу криптовалюту було повернуто. Кошти з\'являться у вашому гаманці найближчим часом.',
  'errorStep.genericDesc': 'Сталася неочікувана помилка. Будь ласка, спробуйте знову.',
  'errorStep.orderId': 'ID замовлення',
  'errorStep.tryAgain': 'Спробувати знову',
  'errorStep.startOver': 'Почати спочатку',
  'errorStep.return': 'Повернутися',
  'errorStep.needHelp': 'Потрібна допомога? Зверніться до ',
  'errorStep.reference': 'Довідка: {orderId}',
  'confirm.buyTitle': 'Підтвердження покупки',
  'confirm.sellTitle': 'Підтвердження продажу',
  'confirm.loading': 'Завантаження...',
  'confirm.provider': 'Провайдер',
  'confirm.youPay': 'Ви сплачуєте',
  'confirm.youSell': 'Ви продаєте',
  'confirm.youReceive': 'Ви отримуєте',
  'confirm.wallet': 'Гаманець',
  'confirm.network': 'Мережа',
  'confirm.refundAddress': 'Адреса повернення',
  'confirm.parityNote': 'Сума, стягнута провайдером, може відрізнятися. Решта до {amount} {crypto} буде зараховано на ваш рахунок {partner}.',
  'confirm.processing': 'Обробка...',
  'confirm.confirmPay': 'Підтвердити і сплатити',
  'confirm.confirmSell': 'Підтвердити і продати',
  'confirm.payout': 'Виплата в {currency}',
  'modal.selectFiat': 'Оберіть фіатну валюту',
  'modal.selectCrypto': 'Оберіть криптовалюту',
  'modal.choosePayment': 'Оберіть спосіб оплати',
  'modal.selectCountry': 'Оберіть вашу країну',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Популярні',
  'modal.recommended': 'Рекомендовані',
  'modal.noCurrencies': 'Валют не знайдено',
  'modal.noPaymentMethods': 'Способів оплати не знайдено',
  'modal.noCountries': 'Країн не знайдено',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Розташування',
  'settings.darkMode': 'Темний режим',
  'settings.privacy': 'Політика конфіденційності',
  'settings.terms': 'Умови використання',
  'settings.language': 'Мова',
  // ─── Additional ───
  'modal.chooseRamp': 'Оберіть Ramp',
  'modal.bestPrice': 'Найкраща ціна',
  'modal.noQuotes': 'Немає котирувань для цього запиту',
  'modal.noProvidersFound': 'Провайдерів не знайдено',
  'payment.unavailableFor': 'Немає способів оплати для {currency}',
  'skeleton.poweredBy': 'Працює на NowRamp',
  'error.createOrderFailed': 'Не вдалося створити замовлення',
  'errorStep.returnToMerchant': 'Повернутися до продавця',
  'confirm.cryptoOnNetwork': '{crypto} на {network}',
  'payment.name.card': 'Карта',
  'payment.name.bankTransfer': 'Банківський переказ',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default uk;
